import { render, staticRenderFns } from "./SplitDropdown.vue?vue&type=template&id=bb00a0ee&scoped=true"
import script from "./SplitDropdown.vue?vue&type=script&lang=js"
export * from "./SplitDropdown.vue?vue&type=script&lang=js"
import style0 from "./SplitDropdown.vue?vue&type=style&index=0&id=bb00a0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb00a0ee",
  null
  
)

export default component.exports